import { QuoteType } from 'src/utils/QuoteType'

export interface IAdditionalQuoteSummary {
  quoteType: QuoteType
  startDate: Date
  numberOfDays: number
  IncludedNonBilledOutClaims: boolean
}

export class AdditionalQuoteSummary implements IAdditionalQuoteSummary {
  public quoteType: QuoteType
  public startDate: Date
  public numberOfDays: number
  public IncludedNonBilledOutClaims: boolean
}
